module.exports = __webpack_public_path__ + "static/media/covi_can_was_han.83f70722.png";